import React from "react";
import { default as i18next } from "i18next";

import fr_CA from "./i18n/fr_CA";
// import en_CA from "./i18n/fr_CA";

i18next.addResourceBundle("fr-CA", "iType", fr_CA);

const config = {
  settings: {},
  name: "Types d'interventions",
  auth: "interventionTypes",
  routes: [
    {
      path: "/app/intervention_types",
      component: React.lazy(() => import("./views/List")),
    },
  ],
};

export default config;
